class ProductCardForm extends HTMLElement {
    constructor() {
        super();

        this.form = this.querySelector('.js-product-card-form');
        this.inputs = this.querySelectorAll('input[type="radio"]');
        this.priceWrappers = document.querySelectorAll('.js-product-card-form-price');
        this.button = this.querySelector('button[type="submit"]');
        this.buttonText = this.button?.querySelector('span');
        this.stickyButton = document.querySelector('.button--shop-fixed');
        this.stickyButtonText = this.stickyButton?.querySelector('.button--shop-fixed span');
        this.isRefillProduct = this.querySelector('.refill-product');
        this.quantityInput = this.querySelector('.js-product-card-quantity');
        this.quantityButtons = this.querySelectorAll('.js-product-card-quantity-button');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.type = this.dataset.type;

        this.form.addEventListener('submit', this.onFormSubmit.bind(this));

        this.inputs.forEach(input => {
            input.addEventListener('change', this.onInputChange.bind(this));
        });

        this.quantityButtons.forEach(quantityButton => {
            quantityButton.addEventListener('click', this.onQuantityButtonClick.bind(this));
        });
    }

    onQuantityButtonClick(e) {
        e.preventDefault();
        const currentButton = e.target;
        const value = +this.quantityInput.value;

        if (currentButton.dataset.type === 'minus') {
            this.quantityInput.value = value > this.quantityInput.min ? value - 1 : this.quantityInput.value;
        } else {
            this.quantityInput.value = value <= this.quantityInput.max ? value + 1 : this.quantityInput.value;
        }
    }

    onInputChange(e) {
        const currentInput = e.target;

        this.inputs.forEach(input => {
            input.classList.remove('js-product-card-input-checked');
        });

        this.priceWrappers.forEach(priceWrapper => {
            priceWrapper.classList.remove('product-card__content-price-wrapper--visible');
        })

        currentInput.classList.add('js-product-card-input-checked');
        document.querySelectorAll(`.js-product-card-form-price[data-id="${currentInput.value}"]`).forEach(card => {
            card.classList.add('product-card__content-price-wrapper--visible');
        });
    }

    updateForm(data) {
        if ((window.accountType === 'family' && this.isRefillProduct) || !this.isRefillProduct) {
            this.variantsLoading(false);
            return null;
        }

        if (data.quantity === 0) {
            this.inputs.forEach(input => {
                input.disabled = false;
            });

            this.button.disabled = false;

            if (this.stickyButton) {
                this.stickyButton.removeAttribute('disabled');
            }

            if (this.type !== 'card') {
                this.buttonText.innerText = this.button.dataset.addToCart;

                if (this.stickyButtonText) {
                    this.stickyButtonText.innerText = this.button.dataset.addToCart;
                }
            }
        } else if (data.quantity < 4) {
            this.inputs.forEach(input => {
                if (data.id !== +input.value) {
                    input.disabled = true;
                } else {
                    input.checked = true;
                    input.disabled = false;
                }
            });

            this.button.disabled = false;

            if (this.stickyButton) {
                this.stickyButton.removeAttribute('disabled');
            }

            if (this.type !== 'card') {
                this.buttonText.innerText = this.button.dataset.addToCart;

                if (this.stickyButtonText) {
                    this.stickyButtonText.innerText = this.button.dataset.addToCart;
                }
            }
        } else {
            if (!document.querySelector(".collection--no-block-refill") || !this.isRefillProduct) {
                this.button.disabled = true;

                if (this.stickyButton) {
                    this.stickyButton.setAttribute('disabled', 'true');

                    if (this.stickyButtonText) {
                        this.stickyButtonText.innerText = this.button.dataset.soldOut;
                    }
                }

                this.inputs.forEach(input => {
                    input.disabled = true;
                });

                if (this.type !== 'card') {
                    this.buttonText.innerText = this.button.dataset.soldOut;
                }

                this.quantityButtons.forEach(quantityButton => {
                    quantityButton.disabled = true;
                });
            }
        }

        this.quantityInput.max = 4 - data.quantity;
        this.quantityInput.value = 1;
        this.variantsLoading(false);
    }

    variantsLoading(isLoading) {
        this.inputs.forEach((input) => {
            let variantWrapper = input.closest('.product-info__variant');

            if (isLoading) {
                variantWrapper.classList.add('product-info__variant--loading');
            } else {
                variantWrapper.classList.remove('product-info__variant--loading');
            }
        })
    }

      flashAddedToCartPopup() {
          const addedToCartPopup = document.getElementById("addedToCartPopup");
          addedToCartPopup.style.visibility = "visible";
          window.setTimeout(() => {
            addedToCartPopup.style.visibility = "hidden";
          }, 5000);
      }


    onFormSubmit(e) {
        e.preventDefault();
        this.button.style.pointerEvents = 'none'

        const currentId = this.form.querySelector('.js-product-card-input-checked').value;
        const quantity = +this.quantityInput.value;
        const productData = {
            id: currentId,
            quantity: quantity,
            sections: this.cart.getSectionsToRender().map((section) => section.id),
            sections_url: window.location.pathname
        };

        this.cart.setActiveElement(document.activeElement);

        this.variantsLoading(true);

        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(productData)
        })
          .then(response => response.json())
          .then(data => {
              this.cart.renderContents(data);
              this.cart.open(e.target);
              this.updateForm(data);
          }).catch(error => {
            console.error('Error adding item to cart:', error);
        }).finally(() => {
            let cartAmount = document.getElementById('cartAmount');
            this.flashAddedToCartPopup();
            if(cartAmount.innerHTML) {
                cartAmount.innerHTML = `${parseInt(cartAmount.innerHTML) + quantity}`;

                if((parseInt(cartAmount.innerHTML) + +this.quantityInput.value) > 0) {
                    cartAmount.classList.remove('cart-toggle-amout--hidden');
                }
            } else {
                cartAmount.innerHTML = '0';
            }

            this.button.style.pointerEvents = 'auto'
        });
    }
}

customElements.define('product-card-form', ProductCardForm);
